import { render, staticRenderFns } from "./SwitchForm.vue?vue&type=template&id=41a23da9"
import script from "./SwitchForm.vue?vue&type=script&lang=js"
export * from "./SwitchForm.vue?vue&type=script&lang=js"
import style0 from "./SwitchForm.vue?vue&type=style&index=0&id=41a23da9&prod&lang=scss"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports